import React, { useEffect } from 'react';
import { useModal } from '../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ModalVariant } from '../../../components/shared/modal-provider/components/modal/modal.constants';
import { ConfirmResetPasswordPageStyled } from './complete-reset-password-page.styled';
import Form from '../../../components/shared/form/form';
import { ValidationConfirmResetPassword } from './complete-reset-password.constants';
import CompleteResetPasswordForm from './components/complete-reset-password-form';
import {
  confirmResetPasswordAction,
  resetPasswordResetState,
} from '../../../store/auth/reset-password.store';
import i18n from '../../../translations/strings';
import LinearLoading from '../../../components/base/loading/linear-loading/linear-loading';

const ConfirmResetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openModal } = useModal();
  const [searchParams] = useSearchParams();

  const { confirmResetPasswordSuccess, loading, error } = useSelector(
    (state: any) => {
      return state.resetPassword;
    },
  );

  useEffect(() => {
    if (confirmResetPasswordSuccess) {
      openModal({
        message: i18n.t(
          'confirmResetPassword.confirmResetPasswordSuccessMessage',
        ),
        variant: ModalVariant.Success,
        handleCloseModal: () => {
          dispatch(resetPasswordResetState());
          navigate('/login', { replace: true });
        },
      });
    }
  }, [confirmResetPasswordSuccess]);

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
        handleCloseModal: () => dispatch(resetPasswordResetState()),
      });
    }
  }, [error]);

  const onSubmit = (data: any) => {
    const uid = searchParams.get('uid');
    const token = searchParams.get('token');
    if (uid && token) {
      const dataToSend = {
        uid,
        token,
        password: data.password,
        confirm_password: data.confirm_password,
      };
      dispatch(confirmResetPasswordAction(dataToSend));
    }
  };

  return (
    <ConfirmResetPasswordPageStyled.Container container>
      <LinearLoading loading={loading} />
      <ConfirmResetPasswordPageStyled.ContainerForm item md={5} xs={12}>
        <ConfirmResetPasswordPageStyled.Title>
          {i18n.t('confirmResetPassword.titlePage')}
        </ConfirmResetPasswordPageStyled.Title>
        <Form schema={ValidationConfirmResetPassword}>
          <CompleteResetPasswordForm onSubmit={onSubmit} />
        </Form>
      </ConfirmResetPasswordPageStyled.ContainerForm>
    </ConfirmResetPasswordPageStyled.Container>
  );
};

export default ConfirmResetPasswordPage;
